/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { useTranslation } from 'next-i18next';
import React from 'react';

import Cross from '@toucan/client/global/icons/legacy/cross.svg';

import {
    IconButton,
    IconButtonFill,
    IconButtonSize,
} from '@toucan/client/shared/components/icon-button';
import { Link, LinkSize } from '@toucan/client/shared/components/link';

export const FilterHeader = ({
    resultsCount,
    hasSelectedFilters,
    handleClearAll,
    onResetAndClose,
}: {
    resultsCount: number;
    hasSelectedFilters: boolean;
    handleClearAll: () => void;
    onResetAndClose: () => void;
}) => {
    const { t } = useTranslation();

    return (
        <div className="filter-header">
            <Heading size={HeadingSize.H3} className="filter-header-title">
                {t('Filters')}
            </Heading>

            <IconButton
                label={t('Close')}
                fill={IconButtonFill.HOLLOW}
                border={false}
                size={IconButtonSize.MEDIUM}
                className="filter-header-close"
                onClick={onResetAndClose}
                data-testid="mobile-search-filter__close"
            >
                <Cross />
            </IconButton>
            <p
                className="filter-header-results"
                data-testid="filter-header__results-count"
            >
                <strong>{resultsCount}</strong> {t('results')}
            </p>
            {hasSelectedFilters && (
                <Link
                    size={LinkSize.SMALL}
                    className="filter-header-clear"
                    data-testid="mobile-search-filter__clear-all"
                    onClick={handleClearAll}
                >
                    {t('Clear all filters')}
                </Link>
            )}
        </div>
    );
};
